import { render } from "./Sourcing.vue?vue&type=template&id=3b6aeff4&scoped=true"
import script from "./Sourcing.vue?vue&type=script&lang=js"
export * from "./Sourcing.vue?vue&type=script&lang=js"

import "@/assets/css/layout_request.css?vue&type=style&index=0&id=3b6aeff4&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b6aeff4"]])

export default __exports__